<template>
  <div
    class="drawer-info__head"
    data-ui-section="drawer-head"
  >
    <VsButton
      icon="md:minimize"
      class="
        drawer-info__head drawer-info__head--type
        p-0 text-white
      "
      @click="toggleSidePanel"
    />
    <VsButton
      v-if="publicUrl"
      icon="md:playlist_play"
      :href="publicUrl"
      :tracker="getAnalyticPayload(
        e => e.player['video-drawer'].click['drawer-link'],
        publicUrl)"
      class="drawer-info__head drawer-info__head--type p-0 text-white"
    >
      <span v-if="publicUrl">Open</span>
      <span>{{ type | toFriendlyType }}</span>
    </VsButton>

    <VsButton
      v-if="author"
      :href="author.publicUrl"
      :tracker="
        getAnalyticPayload(
          e => e.player['video-drawer'].click['author-link'],
          author
        )"
      class="drawer-info__head drawer-info__head--author p-0 text-white"
      icon="md:account_circle"
    >
      {{ author.displayName }}
    </VsButton>
  </div>
</template>

<script>
import startCase from 'lodash/startCase';
import { getAnalyticPayload } from '@/scripts/libs/analytic';
import VsButton from '@/scripts/Components/Molecules/VsButton';
import { CollectionInfoFriendlyTypeMap } from '@/scripts/models/videoCollections/implementations/core/collection-info-friendy-type-map';

export default {
  components: {
    VsButton,
  },
  filters: {
    toFriendlyType(type) {
      return startCase(CollectionInfoFriendlyTypeMap[type] || type);
    },
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    author: {
      type: Object,
      default: undefined,
    },
    publicUrl: {
      type: String,
      default: undefined,
    },
  },

  methods: {
    getAnalyticPayload,
    toggleSidePanel() {
      this.$emit('toggle-side');
    },
  },
};
</script>

<style lang="scss">
.drawer-info__head {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
}
.drawer-info__head {
  color: rgba(white, 0.75);
  margin-right: 8px;

  .vs-icon {
    font-size: 21px;
    margin-right: -4px;
  }
  .vs-icon ~ span {
    font-size: 12px;
  }
  .vs-icon,
  .vs-icon ~ span {
    vertical-align: middle;
  }
  .vs-icon ~ span:last-child {
    text-transform: capitalize;
  }
}
.drawer-info__head.drawer-info__head--author {
  .vs-icon {
    font-size: 15px;
    margin-right: 0px;
  }
}
</style>
